import {
  Card,
  CustomerRoleTypeBadge,
  InfoTooltip,
  Text,
  VSpacer,
} from '@/components/DesignSystem';
import { ApiUser } from '@api/interfaces/ApiUser';
import { Skeleton, Stack, useTheme } from '@mui/material';
import React from 'react';


interface KPICardProps {
  boundaryRef?: React.RefObject<HTMLElement>,
  farmer?: ApiUser,
  iconColor?: string,
  label: string,
  openTooltipOnClick?: boolean,
  sublabel?: string,
  testID: string,
  tooltipText?: string,
  valueText?: string,
  variant?: 'default' | 'centered',
}

const variantStyles = {
  default: {
    card: {
      padding: '12px',
      width: '100%',
    },
    label:{},
  },
  centered: {
    card: {
      borderRadius: '4px',
      flex: 1,
      minHeight: '82px',
      padding: '14px 12px 16px 16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    label: {
      fontWeight: 500,
      fontSize: '11px',
      lineHeight: '13px',
      letterSpacing: '0.75px',
      textTransform: 'uppercase',
    },
  },
};

export const KPICard = ({
  boundaryRef,
  farmer,
  iconColor = '#0288D1',
  label,
  openTooltipOnClick = false,
  sublabel,
  testID,
  tooltipText,
  valueText,
  variant = 'default',
}: KPICardProps) => {
  const theme = useTheme();
  const styles = variantStyles[variant];

  return (
    <Card
      cardContentStyle={{
        height: '100%',
        padding: 0,
        width: '100%',
        '&:last-child': {
          paddingBottom: '0px',
        },
      }}
      sx={styles.card}
      testID={testID}
    >
      <Stack
        justifyContent={variant === 'centered' ? 'space-between' : ''}
      >
        <Stack alignItems="center" direction="row" gap="4px">
          <Text
            category="body-medium"
            noWrap={variant !== 'centered'}
            sx={variant === 'centered' ? styles.label : undefined}
          >
            {label}
          </Text>
          {!!tooltipText && (
            <InfoTooltip
              backgroundColor={variant === 'centered'
                ? theme.palette.background.paper : undefined}
              boundaryRef={boundaryRef}
              iconColor={iconColor}
              openOnClick={openTooltipOnClick}
            >
              {tooltipText}
            </InfoTooltip>
          )}
        </Stack>
        <Text category="body-small" lineHeight="20px" noWrap>
          <i>{sublabel ?? ' '}</i>
        </Text>
      </Stack>
      <VSpacer size="4" />
      {valueText ? (
        <Text breakWord fontSize="24px" fontWeight={500}>
          {valueText}
        </Text>
      ) : (
        <Skeleton height="30px" variant="text" width="80%" />
      )}
      {!!farmer?.accountGroupRole && (
        <>
          <VSpacer size="4" />
          <CustomerRoleTypeBadge
            accountGroupRole={farmer.accountGroupRole}
            testID={`${testID}-badge`}
          />
        </>
      )}
    </Card>
  );
};
